import clsx from 'clsx';
import React from 'react';
import { Link as ReactLink } from 'react-router-dom';

import styles from './link.module.css';

interface LinkProps extends React.LinkHTMLAttributes<HTMLLinkElement> {
	to: string;
	children: React.ReactNode;
	underline?: boolean;
	className?: string;
	state?: any;
	target?: '_blank' | '_self';
}

const Link = (props: LinkProps) => {
	const { to, children, underline, className, state, target } = props;
	return (
		<ReactLink
			className={clsx(styles.default, className, underline && styles.underline)}
			state={state}
			target={target}
			to={to}
		>
			{children}
		</ReactLink>
	);
};

export default Link;
